import { leadership } from "@/mocks/homeData";

export default function Leadership() {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="section-container">
        <div className="text-center mb-14 animate-on-scroll">
          <div className="inline-flex items-center px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium mb-5">
            Leadership
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-foreground-800 mb-3">
            MANAGEMENT
          </h2>
          <p className="text-foreground-500 max-w-[560px] mx-auto leading-relaxed">
            We strongly believe in team work. We are honest, sincere, dedicated,
            punctual & committed to our clients is the core asset of BA
            Fashionwear Limited
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {leadership.map((person, i) => (
            <div
              key={i}
              className={`w-full sm:w-64 lg:w-72 group animate-on-scroll animate-on-scroll-delay-${(i % 4) + 1}`}
            >
              <div className="relative overflow-hidden rounded-lg aspect-[4/5] mb-4">
                <img
                  src={person.image}
                  alt={person.name}
                  className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <h3 className="text-sm font-heading font-semibold text-foreground-800 mb-0.5">
                {person.name}
              </h3>
              <p className="text-xs text-accent-400 font-medium mb-2">
                {person.role}
              </p>
            
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
